module.exports = __webpack_public_path__ + "img/1280.445792c2.svg";